import type { ReactElement, ReactNode } from 'react';

export interface FieldProps {
  readonly id: string;
  readonly label: string;
  /** Units and meaning, e.g. «проценты ROI от маржи». Always spell units out. */
  readonly hint?: string;
  readonly error?: string | undefined;
  readonly children: ReactNode;
}

/**
 * Label + control + hint + error, wired together for screen readers.
 *
 * The control must use `id={id}` and `aria-describedby={`${id}-hint`}` where a
 * hint exists; the error is a live region so a validation failure is announced
 * rather than only appearing in red.
 */
export function Field({ id, label, hint, error, children }: FieldProps): ReactElement {
  return (
    <div className="field">
      <label className="field__label" htmlFor={id}>
        {label}
      </label>
      {children}
      {hint !== undefined && (
        <span className="field__hint" id={`${id}-hint`}>
          {hint}
        </span>
      )}
      {error !== undefined && (
        <span className="field__error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
}
